import React from "react";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import { FileText } from "lucide-react";
import { INK, PRIMARY, Overline, AuroraBlue, AuroraLight, Reveal } from "../components/shared/kursusUi";

const UdliciteringPage = () => {
  // Course data with AK-codes
  const courses = [
    { kursus: "Varebil grunduddannelse", akKode: "AK-48850" },
    { kursus: "Varebil efteruddannelse", akKode: "AK-48851" },
  ];

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'hsl(210, 20%, 98%)' }}>
      <div className="votra-grain" aria-hidden />
      <Header />

      {/* Hero — dark ink + blue aurora */}
      <section className="hero-light relative overflow-hidden" style={{ backgroundColor: '#F4F6FB' }}>
        <AuroraLight />
        <div className="fx-scan"><span /></div>
        <div className="container mx-auto px-4 md:px-6 relative z-10 py-16 md:py-24 text-center">
          <Reveal className="flex justify-center">
            <span className="w-14 h-14 rounded-2xl bg-white/10 backdrop-blur-sm flex items-center justify-center mb-4">
              <FileText className="h-7 w-7 text-white" />
            </span>
          </Reveal>
          <Reveal i={1} className="flex justify-center"><Overline light>Samarbejde</Overline></Reveal>
          <Reveal i={2}>
            <h1 className="font-display text-4xl md:text-5xl font-medium text-white leading-tight mb-5">Samarbejde</h1>
          </Reveal>
          <Reveal i={3}>
            <p className="text-lg text-slate-300 leading-relaxed max-w-2xl mx-auto">
              Oversigt over vores kurser i samarbejde med UCplus og deres AK-koder
            </p>
          </Reveal>
        </div>
      </section>

      {/* Content */}
      <div className="container mx-auto px-4 md:px-6 py-16 md:py-20 flex-1">
        <div className="max-w-4xl mx-auto">
          <Reveal className="bg-white rounded-3xl border border-slate-200/80 overflow-hidden shadow-[0_8px_30px_rgba(15,40,90,0.06)]">
            {/* Table Header */}
            <div className="p-8 text-center text-white relative overflow-hidden" style={{ backgroundColor: INK }}>
              <AuroraBlue />
              <h2 className="relative z-10 font-display text-xl md:text-2xl font-medium">
                Udlicitering hos UCplus
              </h2>
            </div>

            {/* Table */}
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="bg-slate-50 border-b border-slate-200">
                    <th className="text-left px-6 py-4 font-semibold text-slate-700">Kursus</th>
                    <th className="text-left px-6 py-4 font-semibold text-slate-700 w-40">AK-kode</th>
                  </tr>
                </thead>
                <tbody>
                  {courses.map((course, idx) => (
                    <tr
                      key={idx}
                      className={`border-b border-slate-100 hover:bg-slate-50 transition-colors ${idx % 2 === 0 ? 'bg-white' : 'bg-slate-50/50'}`}
                    >
                      <td className="px-6 py-4 text-slate-700 font-medium">{course.kursus}</td>
                      <td className="px-6 py-4 font-mono font-semibold" style={{ color: PRIMARY }}>{course.akKode}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Footer note */}
            <div className="bg-slate-50 p-4 text-center text-sm text-slate-500 border-t border-slate-200">
              AK-koder bruges til tilmelding via AMU-systemet
            </div>
          </Reveal>

          {/* Additional info */}
          <Reveal className="mt-8 rounded-3xl p-6 md:p-8 border" style={{ backgroundColor: 'hsl(210,100%,45%,0.06)', borderColor: 'hsl(210,100%,45%,0.18)' }}>
            <h3 className="font-display text-lg font-medium text-slate-900 mb-2">Om samarbejdet</h3>
            <p className="text-slate-600 leading-relaxed">
              Votra Danmark ApS har indgået samarbejdsaftale med UCplus.
            </p>
          </Reveal>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default UdliciteringPage;
